import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const useArchiveName = (archive, archiveName) => {
  const {
    file
  } = archive;
  const [name, setName] = React.useState(archiveName !== null && archiveName !== void 0 ? archiveName : null);
  React.useEffect(() => {
    if (archiveName) setName(archiveName);else if (file) setName(file.name);
  }, [file, archiveName]);
  return name;
};